export function timeLeft(expires: number|Date|undefined): TimeLeft|undefined
{
    if (undefined === expires)
        return;

    const expiresTime: number = typeof(expires) === "number" ? expires : expires.getTime();

    const totalSecondsLeft = (expiresTime - (new Date()).getTime()) / 1000;
    const hoursLeft = Math.floor(totalSecondsLeft/(60*60));
    const minutesLeft = Math.floor((totalSecondsLeft/60)%60);
    const secondsLeft = Math.floor(totalSecondsLeft % 60);

    return {
        hours: hoursLeft,
        minutes: minutesLeft,
        seconds: secondsLeft,
    }
}

// Convert time left to a HH:mm:ss string
export function timeLeftString(timeLeft: TimeLeft|undefined, showHoursIfNone: boolean = true): string|undefined
{
    if (undefined === timeLeft)
        return;

    // Get the hours string with the colon
    let hoursString = (0 === timeLeft.hours && showHoursIfNone) ? "00:" : "";
    if (timeLeft.hours > 0)
        hoursString = timePartToString(timeLeft.hours, true) + ":";
    
    return `${hoursString}${timePartToString(timeLeft.minutes)}:${timePartToString(timeLeft.seconds)}`;
}

// Take a time part number and convert to a string
export function timePartToString(timePart: number, allowOver59: boolean = false): string
{
    const timePartFloor = Math.floor(timePart);
    if (timePartFloor > 59 && allowOver59)
        return timePartFloor.toString();

    return ("00" + timePart).substr(-2);
}


export interface TimeLeft {
    hours:number,
    minutes:number,
    seconds:number
}
export interface TimeLeftStrings {
    hours:string,
    minutes:string,
    seconds:string
} 

